import classnames from 'classnames/bind'
import React from 'react'

import ArticleItem, { ArticleItemProps } from '~/components/ArticleItem'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface ArticleBigProps {
  className?: string
  article?: ArticleItemProps
}

function ArticleBig({ className, article }: ArticleBigProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })

  return (
    <div className={cx(css.ArticleBig, className)}>
      <div className={gridStyle}>
        <ArticleItem className={css.article} {...article} big />
      </div>
    </div>
  )
}

ArticleBig.defaultProps = {}

export default ArticleBig
